import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import TheMask from 'vue-the-mask';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

import dayjs from '@/plugins/dayjs';
import vmoney from '@/plugins/vmoney';

import { createPinia } from 'pinia';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue)
            .use(TheMask)
            .use(dayjs)
            .use(vmoney)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

console.warn = () => {};
